import React, { useState } from 'react';
import { auth, db } from '../firebaseConfig'; // Import db
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore'; // Import setDoc

const Signup = ({ toggleView, theme, toggleTheme }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState(''); // New state for display name
  const [role, setRole] = useState('Founder'); // New state for role
  const [error, setError] = useState(null);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError(null);
    if (!displayName) {
      setError("Please enter a display name.");
      return;
    }

    try {
      // Step 1: Create the user in Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      console.log('User created in Auth, UID:', user.uid);

      // Step 2: Create a user profile document in Firestore
      // We use the user's UID from Auth as the document ID in Firestore
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email: user.email,
        displayName: displayName,
        role: role,
        createdAt: new Date()
      });

      console.log('User profile created in Firestore!');
      // The user is now signed up and logged in. The main App component will handle the redirect.

    } catch (error) {
      console.error("Error signing up:", error);
      setError(error.message);
    }
  };

  return (
    <div className="auth-container">
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <h2>Create Account</h2>
        <button onClick={toggleTheme} className="theme-toggle">
            {theme === 'dark' ? '☀️' : '🌙'}
        </button>
      </div>
      <form onSubmit={handleSignup} className="auth-form">
        <input
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          placeholder="Display Name (e.g., RUGHA)"
          required
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="Founder">Founder</option>
            <option value="Employee">Employee</option>
            <option value="Investor">Investor</option>
        </select>
        <button type="submit">Sign Up</button>
        {error && <p style={{color: 'var(--brand-danger)'}}>{error}</p>}
      </form>
      <p className="auth-toggle">
        Already have an account? <span onClick={() => toggleView('login')}>Login</span>
      </p>
    </div>
  );
};

export default Signup;
